<!-- 
You can use this modal for most confirmation stuff.
It includes a list of elements(optional) that should correspond to the elements to confirm operation on,
a message to display, and a second message(optional) to display.
Customize the title, okTitle, cancelTitle, okVariant, and size as needed.
It emits a 'confirm' event when the user clicks the confirm button.
Messages are HTML, so feel free to use HTML tags.
-->
<template>
  <b-modal
    :id="id"
    :title="title"
    :okTitle="title"
    :okVariant="okVariant"
    :cancelTitle="trans('cancel')"
    buttonSize="sm"
    :size="size"
    @ok="onConfirm"
  >
    <p v-if="message" v-html="message"></p>
    <ul v-if="elements">
      <li v-for="(element, index) in elements" :key="index">{{ element }}</li>
    </ul>
    <div v-if="secondMessage">
      <hr />
      <p v-html="secondMessage"></p>
    </div>
  </b-modal>
</template>

<script>

  export default {
    props: {
      id: {
        type: String,
        default: 'confirm-modal'
      },
      title: {
        type: String,
        default: trans('confirm')
      },
      okVariant: {
        type: String,
        default: 'danger'
      },
      okTitle: {
        type: String,
        default: trans('confirm')
      },
      message: {
        type: String // can be HTML
      },
      secondMessage: {
        type: String, // can be HTML
        default: null
      },
      size: {
        type: String,
        default: 'sm'
      },
      elements: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        trans: trans
      }
    },
    methods: {
      onConfirm() {
        this.$emit('confirm')
      }
    },
    mounted() {
      window.confirmModal = this
    }
  }

</script>